import { createApp } from "vue";
import { VueFire, VueFireAuth } from "vuefire";

import "./styles/my-styles.scss";

import App from "./App.vue";
import router from "./router";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCI2VeJjYSSUc-JTU-kK8D-jSHvQGc1KEs",
  authDomain: "appscontrini.firebaseapp.com",
  projectId: "appscontrini",
  storageBucket: "appscontrini.appspot.com",
  messagingSenderId: "596440661132",
  appId: "1:596440661132:web:39fa80ad896bd9a00f0fa9",
  measurementId: "G-V6BSR4J9YM",
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

const app = createApp(App);

app.use(router);
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
});

// alias
app.config.globalProperties.$analytics = analytics;

app.mount("#app");
